(function($, duo, undefined) {

  "use strict";

  /**
  * Get focusable elements from inside a container
  * @class Focusable
  */
  class Focusable {

    /**
    * Creates an instance of Focusable
    * @param {string} selector css selector for the container
    */
    constructor(selector) {
      this._selector = selector;
      this._element = $(selector);

      this._firstFocusable = null;
      this._lastFocusable = null;

      // setup:
      this._setup();
    } /* constructor */

    _setup() {
      // get the first and the last focusable elements of the container element:
      // (note: this won't work properly if the elements have "visibility: hidden")
      const focusableElements = this._element.find(this.constructor.focusableElementsString).filter(':visible');
      this._firstFocusable = focusableElements[0];
      this._lastFocusable = focusableElements[focusableElements.length - 1];
    } /* _setup */

    reInit() {
      this._setup();
    }

    /**
    * Getter - first focusable element
    */
    get firstFocusableElement() {
      return this._firstFocusable;
    } /* firstFocusableElement */

    /**
    * Getter - last focusable element
    */
    get lastFocusableElement() {
      return this._lastFocusable;
    } /* lastFocusableElement */

    /**
    * CSS query string for focusable elements
    * @readonly
    * @static
    */
    static get focusableElementsString() {
      return [
        'a[href]:not([tabindex^="-"]):not([inert])',
        'area[href]:not([tabindex^="-"]):not([inert])',
        'button:not([disabled]):not([inert])',
        'input:not([disabled]):not([inert])',
        'select:not([disabled]):not([inert])',
        'textarea:not([disabled]):not([inert])',
        'datalist:not([tabindex^="-"]):not([inert])',
        'iframe:not([tabindex^="-"]):not([inert])',
        'object:not([tabindex^="-"]):not([inert])',
        'embed:not([tabindex^="-"]):not([inert])',
        '[tabindex]:not([tabindex^="-"]):not([inert])',
        '[contenteditable]:not([tabindex^="-"]):not([inert])',
        'audio[controls]',
        'video[controls]',
        'summary:not([tabindex^="-"]):not([inert])',
        'div[tabindex="-1"]:not([inert])'
      ].join();
    } /* focusableElementsString */

  } /* Focusable */

  duo.Focusable = Focusable;

})(jQuery, window.duo = window.duo || {});
